import React from 'react';
import { Card, Form, Input, Button, Select, Typography, message, Divider } from 'antd';
import { ArrowLeftOutlined, UserAddOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createUser } from '../../api/users';

const { Title } = Typography;
const { Option } = Select;

const UserCreate: React.FC = () => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const [form] = Form.useForm();

    const createMutation = useMutation({
        mutationFn: createUser,
        onSuccess: () => {
            message.success('Kullanıcı başarıyla oluşturuldu.');
            queryClient.invalidateQueries({ queryKey: ['adminUsers'] });
            navigate('/admin/users');
        },
        onError: (error: any) => {
            const errorMsg = error.response?.data?.errors?.[0] || 'Kullanıcı oluşturma başarısız.';
            message.error(errorMsg);
        },
    });

    return (
        <div className="p-6 max-w-4xl mx-auto">
            <div className="flex items-center gap-4 mb-6">
                <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/admin/users')} />
                <Title level={2} className="mb-0">Yeni Kullanıcı Ekle</Title>
            </div>

            <Card className="shadow-sm">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={(values) => createMutation.mutate(values)}
                    initialValues={{ role: 'User' }}
                >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                        <Form.Item name="firstName" label="Ad" rules={[{ required: true, message: 'Ad gerekli.' }]}>
                            <Input placeholder="Ad" />
                        </Form.Item>
                        <Form.Item name="lastName" label="Soyad" rules={[{ required: true, message: 'Soyad gerekli.' }]}>
                            <Input placeholder="Soyad" />
                        </Form.Item>
                    </div>

                    <Form.Item name="email" label="E-posta" rules={[{ required: true, type: 'email', message: 'Geçerli bir e-posta gerekli.' }]}>
                        <Input placeholder="E-posta adresi" />
                    </Form.Item>

                    <Form.Item name="password" label="Şifre" rules={[{ required: true, min: 6, message: 'Şifre en az 6 karakter olmalıdır.' }]}>
                        <Input.Password placeholder="Şifre" />
                    </Form.Item>

                    <Form.Item name="role" label="Rol" rules={[{ required: true, message: 'Rol seçimi gerekli.' }]}>
                        <Select>
                            <Option value="User">User</Option>
                            <Option value="Admin">Admin</Option>
                            <Option value="SuperAdmin">SuperAdmin</Option>
                        </Select>
                    </Form.Item>

                    <Divider />

                    <div className="flex justify-start">
                        <Button 
                            type="primary" 
                            icon={<UserAddOutlined />} 
                            htmlType="submit" 
                            loading={createMutation.isPending}
                        >
                            Kullanıcıyı Oluştur
                        </Button>
                    </div>
                </Form>
            </Card>
        </div>
    );
};

export default UserCreate;
